import { render, staticRenderFns } from "./Portfolio_Component.vue?vue&type=template&id=0bcfcf28&scoped=true"
import script from "./Portfolio_Component.vue?vue&type=script&lang=js"
export * from "./Portfolio_Component.vue?vue&type=script&lang=js"
import style0 from "./Portfolio_Component.vue?vue&type=style&index=0&id=0bcfcf28&prod&scoped=true&lang=css"
import style1 from "./Portfolio_Component.vue?vue&type=style&index=1&id=0bcfcf28&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bcfcf28",
  null
  
)

export default component.exports